import ClientManagement from '../pages/ClientManagement/clientManagement'
import ClientManagementDetail from '../pages/ClientManagementDetail/clientManagementDetail'
import { AllServiceStop } from '../pages/AllServiceStop'
import { BaseTheme } from '../pages/BaseTheme/baseTheme'
import { ClientTheme } from '../pages/ClientTheme/clientTheme'
import { FAQ } from '../pages/FAQ'
import { OperatingManual } from '../pages/OperatingManual'

export const routes = (t) => [
    {
        path: '/clientManagement/:id',
        component: ClientManagementDetail,
        needToken: true,
        isAdminRoute: true
    },
    {
        path: '/clientManagement',
        component: ClientManagement,
        needToken: true,
        isAdminRoute: true,
        name: t('clientManagement.title')
    },
    {
        path: '/allServiceStop',
        component: AllServiceStop,
        needToken: true,
        isAdminRoute: true,
        name: t('allServiceStop.title')
    },
    {
        path: '/base-theme',
        component: BaseTheme,
        needToken: true,
        isAdminRoute: true,
        name: t('theme.baseTheme.title')
    },
    {
        path: '/client-theme',
        component: ClientTheme,
        needToken: true,
        isAdminRoute: true,
        name: t('theme.clientTheme.title')
    },
    {
        path: '/faq',
        component: FAQ,
        isMenuRoute: true,
        isAdvancedRoute: true,
        isManagedRoute: true,
        isBasicRoute: true,
        needToken: true
    },
    {
        path: '/operatingManual',
        component: OperatingManual,
        isMenuRoute: true,
        isAdvancedRoute: true,
        isManagedRoute: true,
        isBasicRoute: true,
        needToken: true
    }
]
